import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'fuse-ui/components/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Divider from '@material-ui/core/Divider';

const styles = theme => ( {
    actionBtn: {
        '&:hover': {
            background: 'none'
        },
        '&:last-child': {
            paddingRight: 0,
        },
        bottom: 0,
        margin: 'auto',
        paddingRight: 0,
        position: 'absolute',
        right: '18px',
        top: 0,
        transform: 'rotate(270deg)',
    },
    capitialize: {
        textTransform: 'capitalize'
    },
    divider: {
        margin: `0 -${theme.spacing.unit * 3}px`,
    },
    iconClosed: {
        '&:hover': {
            background: 'none'
        },
        '&:last-child': {
            paddingRight: 0,
        },
        bottom: 0,
        margin: 'auto',
        paddingRight: 0,
        position: 'absolute',
        right: '18px',
        top: 0,
    },
    summaryRoot: {
        margin: `0 -${theme.spacing.unit * 3}px`,
    }
} );

class ExpansionComponent extends Component{
    constructor( props ){
        super( props );
        this.state = {
            expanded: props.expanded,
        };
    }

    handleChange = ( _, expanded ) => {
        this.setState( {
            expanded: expanded ? true : false,
        } );
    };

    render(){
        const { expanded } = this.state;
        const {  classes, title, children, dataAutomationId, noDivider } = this.props;

        return (
            <React.Fragment>
                {
                    !noDivider &&
                    <Divider className={classes.divider}/>
                }
                <MuiExpansionPanel
                    square
                    expanded={expanded}
                    onChange={this.handleChange}
                >
                    <MuiExpansionPanelSummary
                        classes={{ root: classes.summaryRoot }}
                        data-automation-id={dataAutomationId}
                    >
                        <Typography variant="button" className={classes.capitialize}>{title}</Typography>
                        <IconButton
                            className={`icon-button ${expanded ? classes.iconClosed : classes.actionBtn}`}
                            disableRipple={true}
                        >
                            <ExpandMore className={classes.icon} />
                        </IconButton>
                    </MuiExpansionPanelSummary>
                    <MuiExpansionPanelDetails>
                        {
                            React.Children.map( children, ( child ) => child )
                        }
                    </MuiExpansionPanelDetails>
                </MuiExpansionPanel>
            </React.Fragment>
        );
    }
}

ExpansionComponent.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired,
    dataAutomationId: PropTypes.string,
    expanded: PropTypes.bool,
    noDivider: PropTypes.bool,
    title: PropTypes.string,
};

ExpansionComponent.defaultProps = {
    expanded: false,
};

export default withStyles( styles )( ExpansionComponent );
